import Base from './Base';

export default class caseStatus extends Base {
  value = '';
  label = '';

  constructor(props) {
    super();
    this.clone(props);
  }
}
